// extracted by mini-css-extract-plugin
module.exports = {"border":"OfferSection_border__47tQM"};